import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw, WifiOff } from "lucide-react";

// شاشة انقطاع الشبكة: صريحة وبزر إعادة محاولة (آبل 2.1 — لا شاشات فارغة على شبكة سيئة).
export const OfflineNotice = () => {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const up = () => setOffline(false);
    const down = () => setOffline(true);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (!offline) return null;
  return (
    <div className="fixed inset-x-0 top-0 z-[95] flex items-center justify-center gap-3 bg-destructive px-4 py-3 text-white"
         data-testid="offline-notice">
      <WifiOff className="h-4 w-4 shrink-0" />
      <p className="text-sm font-black">{t("app.offlineTitle")}</p>
      <button type="button" data-testid="offline-retry"
              onClick={() => window.location.reload()}
              className="flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 text-xs font-black">
        <RefreshCw className="h-3.5 w-3.5" /> {t("app.retry")}
      </button>
    </div>
  );
};
